<template>
  <a-modal width="800px" :visible="visible" :closable="false">
    <template v-if="revisedDataDownloadable.length > 0">
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="mt-2 mb-3">
          {{ $t('po.revised_list') }}
        </h5>
        <h6>Total: {{ revisedDataDownloadable.length }}</h6>
      </div>
      <a-spin :spinning="isLoading" size="large" :tip="$t('adjustment.uploading')">
        <div>
          <a-table
            :columns="columns"
            :row-key="(record, index) => index"
            :data-source="revisedDataDownloadable"
            :loading="isLoading"
            :pagination="false"
            :scroll="{ y: 330, x: 750 }"
          >
            <template slot="message" slot-scope="text, record">
              <a-tag v-for="(desc, index) in record.message" :key="index" color="red" class="mr-1 mb-1">
                {{ desc }}
              </a-tag>
            </template>
          </a-table>
        </div>
      </a-spin>
    </template>
    <template #footer>
      <a-button key="back" class="mr-2" @click="typeof back !== 'undefined' && back(), onClose()">
        {{ revisedDataDownloadable?.length > 0 ? $t('po.close_no_download') : $t('utils.close') }}
      </a-button>
      <a-button v-if="revisedDataDownloadable.length > 0" type="primary" class="mr-2" @click.prevent="downloadTemplate">
        <a-icon type="download" />
        {{ $t('po.close_download_revised') }}
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import getQueryParam from '@/utils/getQueryParam'
import XLSX from 'xlsx';

export default {
  name: 'ModalFeedbackAfterImport',
  components: {
  },
  mixins: [getQueryParam],
  props: {
    revisedData: Array,
    visible: Boolean,
    back: Function,
    onClose: Function,
    isLoading: Boolean,
  },
  data() {
    return {
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('productAvailability.sku'),
          dataIndex: 'sku',
          key: 'sku',
          width: 190,
        },
        {
          title: this.$t('utils.price'),
          dataIndex: 'price',
          key: 'price',
          width: 120,
        },
        {
          title: this.$t('utils.quantity'),
          dataIndex: 'qty',
          key: 'qty',
          width: 100,
        },
        {
          title: 'UOM',
          dataIndex: 'uom',
          key: 'uom',
          width: 100,
        },
        {
          title: 'Batch Number',
          dataIndex: 'batch_number',
          key: 'batch_number',
          width: 150,
        },
        {
          title: 'Expired Date',
          dataIndex: 'expired_date',
          key: 'expired_date',
          width: 150,
        },
        {
          title: this.$t('adjustment.revisedStatus'),
          dataIndex: 'status',
          key: 'status',
          width: 190,
          scopedSlots: {
            customRender: 'message',
          },
        },
      ]
    },
    revisedDataDownloadable() {
      return this.revisedData
    },
  },
  methods: {
    downloadTemplate() {
      const flattenData = this.revisedDataDownloadable.map((obj) => ({
        sku: obj.sku,
        hargabeli: obj.price,
        quantity: obj.qty,
        uom: obj.uom,
        batch_number: obj.batch_number,
        expired_date: obj.expired_date,
      }))
      const rowData = [
        "SKU",
        "Harga Beli",
        "Quantity",
        "UOM",
        "Batch Number",
        "Expired Date",
      ]
      const worksheet = XLSX.utils.json_to_sheet(flattenData);
      const workbook = XLSX.utils.book_new()
      XLSX.utils.sheet_add_aoa(worksheet, [rowData], { origin: "A1" });
      XLSX.utils.book_append_sheet(workbook, worksheet, 'data')
      XLSX.writeFile(workbook,'file_revised_data_po.xlsx')
      this.onClose()
    },
  },
}
</script>

<style lang="scss" module>
</style>